import React from 'react';

import classNames from 'classnames';
import { useAppSelector } from 'hooks';
import { activeFormatSelector } from 'selectors/drawers';

import { iconApprovePdf } from '../../../icons';
import { IEntity } from '../../../types';
import Achievement from './Achievement';

import './index.scss';

interface ICommonDataEntityProps {
  entity: IEntity;
}

const PdfCommonDataEntity: React.FC<ICommonDataEntityProps> = ({ entity }) => {
  const { features, name, stage, place, types, date, reward, entityProps, achievementImage, list } = entity;
  const format = useAppSelector(activeFormatSelector);
  const isApproved = entityProps.flags?.includes('approved');

  const getRewardResult = (result: string) => {
    if (result.length < 36) return result;
    return `${result.slice(0, 36)}...`;
  };

  return (
    <div
      className={classNames('pdf-data-entity', 'pdf-keep', {
        'pdf-data-entity--horizontal': format === 'horizontal',
      })}
    >
      <div className="pdf-data-entity__info">
        <div className="pdf-data-entity__features-container">
          {features
            .filter((feature) => feature?.text)
            .map((feature) => (
              <p key={feature.text} className="pdf-data-entity__feature">
                {feature.text}
              </p>
            ))}
          {isApproved && (
            <div className="pdf-data-entity__feature pdf-data-entity__feature--approve">
              <img src={iconApprovePdf} alt="подтверждено" />
            </div>
          )}
        </div>
        <h5 className="pdf-data-entity__name">{name}</h5>
        {stage && <p className="pdf-data-entity__stage">{stage}</p>}
        <p className="pdf-data-entity__types">
          {types && types.map((type) => <span key={type + Math.random() * 10}>{type}</span>)}
        </p>
        {place && <p>{place}</p>}
        {date && <p className="pdf-data-entity__date">{date}</p>}
        {list && list.length
          ? list.map((l, index) => (
              <p key={index} className="pdf-data-entity__listItem">
                {l}
              </p>
            ))
          : null}
      </div>
      {reward && (
        <div className="pdf-data-entity__reward reward">
          <div className="reward__info">
            <h5 className="reward__result">{getRewardResult(reward.result)}</h5>
            {reward.rewardDate && <p className="reward__date">{reward.rewardDate}</p>}
          </div>
          <img src={reward.image} />
        </div>
      )}
      {!reward && achievementImage && <Achievement image={achievementImage} />}
    </div>
  );
};

export default PdfCommonDataEntity;
